import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ExportService } from 'src/app/services/export/export.service';
import { HttpInterceptorService } from 'src/app/services/http-interceptor/http-interceptor.service';
import { TranslateService } from '@ngx-translate/core';
import { UserType } from 'src/app/user-roles';
import { TableOptions } from '../../classes/table-options';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddCompanyComponent } from './add-company/add-company.component';
import { TokenService } from '../../services/auth/token/token.service';
import { ToastService } from '../../shared/services/toast/toast.service';

@Component({
  selector: 'sc-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CompaniesComponent {
  isAdminView: boolean = false;
  loadingExport = false;
  tableOptions: TableOptions = new TableOptions(10, 'ID');
  userType = UserType;

  constructor(
    private router: Router,
    private _http: HttpInterceptorService,
    private exportService: ExportService,
    private toastService: ToastService,
    private translate: TranslateService,
    private matDialog: MatDialog,
    private tokenService: TokenService
  ) {}

  addCompany() {
    const dialogRef: MatDialogRef<AddCompanyComponent> = this.matDialog.open(AddCompanyComponent, {
      disableClose: true,
      width: '600px'
    });

    dialogRef.afterClosed().subscribe((company) => {
      if (company) {
        this.tokenService.refreshAccess().then(() => {
          this.selectCompany(company);
        });

        this.toastService.success('COMPANY_CREATED');
      }
    });
  }

  onSearch(search) {
    this.router.navigate(['companies/all'], { state: { searchQuery: search } });
  }

  selectCompany(company) {
    if (company?.PK_CompanyID) {
      this.router.navigate(['companies', company.PK_CompanyID]);
    }
  }

  onExport(type: string) {
    this.loadingExport = true;
    this._http.get(`Companies/export`).subscribe({
      next: (res) => {
        res.forEach((item) => {
          delete item.$id;
        });
        switch (type) {
          case 'CSV':
            this.exportService.exportCSV(res, 'Companies', null, ';');
            break;
          case 'XLS':
            this.exportService.simpleExcelExport(res, 'Companies', ['ApprovedByOwnerDate']);
            break;
          case 'JSON':
            this.exportService.exportJSON(res, 'Companies');
            break;
        }
        this.loadingExport = false;
      },
      error: (err) => {
        this.loadingExport = false;
        this.toastService.error(err);
      }
    });
  }
}
